import { Component } from '@angular/core';
import { SportsCompetitionTreeComponent } from '../../sports-competitio-tree/sportsCompetitionTree.component';
import { EventMappingType, PageType } from 'src/app/models/enums';
import { ISport } from 'src/app/models/sportHierarchy/sport';


@Component({
  selector: 'app-sports-competition-tree-mobile',
  templateUrl: './sports-competitio-tree-mobile.component.html',
  styleUrls: ['./sports-competitio-tree-mobile.component.less']
})

export class SportsCompetitionTreeMobileComponent extends SportsCompetitionTreeComponent {
  public eventsMappingTypeEnum = EventMappingType;


  toggleMostPopularSports(sport: ISport) {
    this.deselectSports();
    sport.isSelected = !sport.isSelected;
    sport.showRegions = !sport.showRegions;
    this.selectedSport = sport;
    this.showMostPopularSports = !this.showMostPopularSports;
    if (this.showMostPopularSports) {
      this.queryParamService.pageType = PageType.MostPopular;
    }
  }


}
